import { memo } from 'react';
import { Tooltip } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';

import { getRelativeTime } from '../../utils/formatRelativeTime';
import { formatCell } from '../../utils/formatCell';

/** Added column: relative time (Just now, 9mo ago) with the absolute date-time in a tooltip. */
const MembersAddedCell = ({ addedAt }) => {
  const { t, i18n } = useTranslation('people-access');
  const relative = getRelativeTime(addedAt);

  if (!relative || Number.isNaN(new Date(addedAt).getTime())) return formatCell(null);

  const absolute = new Intl.DateTimeFormat(i18n?.language, {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(new Date(addedAt));

  return (
    <Tooltip content={absolute} size="compact">
      <span>{t(`members.relative.${relative.key}`, { count: relative.count })}</span>
    </Tooltip>
  );
};

export default memo(MembersAddedCell);
